import React, { useState } from 'react';

// Hooks
import useCustomerActivate from '@src/hooks/useCustomerActivate';

// Comps
import {TextField} from '@arctheme-components/elements/TextField/TextField';
import {Paragraph} from '@project-stories/elements/Paragraph/Paragraph';
import ButtonSpinner from '@project-stories/elements/ButtonSpinner/ButtonSpinner';

const AccountActivateForm = ({ section }) => {
    // Settings
    const {
        password_label,
        password_placeholder,
        confirm_password_label,
        confirm_password_placeholder,
        button_label_activate,
        button_style_activate
    } = section;

    // States
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    // Hooks
    const { error, success, loading, activateCustomer } = useCustomerActivate();

    const handleSubmit = async (event: React.UIEvent<HTMLFormElement>) => {
        event.preventDefault();

        const urlPath = window.location.pathname;
        const split = urlPath.split('/');
        const customerId = split[3];
        const activationToken = split[4];

        activateCustomer(password, confirmPassword, customerId, activationToken);
    };

    return (
        <form
            data-shopify-captcha='true'
            id='resetForm'
            onSubmit={handleSubmit}
            className='account-page__form'
        >
            <div className='flex flex-col gap-y-6 items-center max-w-[420px] mx-auto'>
                <TextField
                    inputType='password'
                    id='passwordActivate'
                    name='passwordActivate'
                    className={`w-full`}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required={false}
                    label={password_label}
                    placeholder={password_placeholder}
                />

                <TextField
                    inputType='password'
                    id='confirmPasswordActivate'
                    name='confirmPasswordActivate'
                    className={`w-full`}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required={false}
                    label={confirm_password_label}
                    placeholder={confirm_password_placeholder}
                />

                {error && (
                    <Paragraph
                        text={error}
                        type='errors text-center'
                    />
                )}

                {success && (
                    <Paragraph
                        text='Successfully activated your account'
                        type='text-center success'
                    />
                )}

                <ButtonSpinner
                    isLoading={loading}
                    classes={`${button_style_activate} w-full text-base button button-primary min-h-[60px] !text-lg block`}
                    ariaLabel='Submit activate account form'
                    loadingText={'Activating'}
                >
                    {button_label_activate}
                </ButtonSpinner>
            </div>
        </form>
    );
};

export default AccountActivateForm;
